import { Directive, ElementRef, inject, OnDestroy, OnInit, output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
  appClickOutside = output<MouseEvent>();

  #elementRef = inject(ElementRef);

  ngOnInit() {
    document.addEventListener('click', this.#onClick, true);
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.#onClick, true);
  }

  #onClick = (event: MouseEvent) => {
    const clickedInside = this.#elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.appClickOutside.emit(event);
    }
  };
}
